import { adminConstants } from './constants';

const INITIAL_STATE = { 
  dayAttendance: []
 };


export function admin(state = INITIAL_STATE, action) {
   switch (action.type) {

   
    
    case adminConstants.GET_DAY_ATTENDANCE:
      return {
          ...state,
          dayAttendance: action.dayAttendance
          };  
        

    default:
      return state; 
  
    }
}

